import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ContactCardList"] */ "/app/src/components/new/ContactCardList/ContactCardList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/ContactForm/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetUserLocationCookie"] */ "/app/src/components/nivaran/main/utils/setUserLocationCookie.tsx");
